// Shared field-level validators for the sign-up and admin tenant-creation
// wizards — both forms are "in sync," so the rules live in one place.

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MOBILE_PATTERN = /^[6-9]\d{9}$/;

export const validateRequiredName = (
  value: string,
  fieldLabel: string,
  { min = 3, max = 50 }: { min?: number; max?: number } = {}
): string | null => {
  const v = value.trim();
  if (!v) return `${fieldLabel} is required`;
  if (v.length < min) return `${fieldLabel} must be at least ${min} characters`;
  if (v.length > max) return `${fieldLabel} must be under ${max} characters`;
  return null;
};

export const validateEmail = (value: string): string | null => {
  const v = value.trim();
  if (!v) return "Email is required";
  if (!EMAIL_PATTERN.test(v)) return "Enter a valid email address";
  return null;
};

export const validateMobile = (value: string): string | null => {
  const v = value.trim();
  if (!v) return "Mobile number is required";
  if (!MOBILE_PATTERN.test(v)) {
    return "Enter a valid 10-digit mobile number starting with 6-9";
  }
  return null;
};

export interface PasswordRule {
  label: string;
  test: (value: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { label: "At least 8 characters", test: (v) => v.length >= 8 },
  { label: "At least one number", test: (v) => /[0-9]/.test(v) },
  { label: "At least one symbol", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const validatePassword = (value: string): string | null => {
  if (!value) return "Password is required";
  const failed = PASSWORD_RULES.find((rule) => !rule.test(value));
  if (failed) return "Password doesn't meet all the requirements below";
  return null;
};

export const IDENTIFIER_MIN_LENGTH = 3;
export const IDENTIFIER_MAX_LENGTH = 30;
